document.addEventListener('DOMContentLoaded', function () {
    function lazyLoadAndAnimate() {
        // 视频懒加载
        $('video.video-lazyload').each(function () {
            var video = $(this);
            var video_top = video.offset().top
            // 如果自定义的触发类名，则滚动到其位置再加载,适用于固定定位的弹窗视频
            if (video.attr('data-class')) {
                video_top = $(video.attr('data-class')).offset().top
            }
            if (video.hasClass('video-lazyload-parent')) {
                video_top = video.parent().offset().top;
            }
            if (video_top < $(window).scrollTop() + $(window).height() && !video.attr('loaded')) {
                if (!video.attr('poster') && video.attr('data-poster')) {
                    video.attr('poster', video.attr('data-poster'))
                }
                video.find('source').attr('src', video.find('source').attr('data-src'));
                video[0].load();
                video.attr('loaded', true);
            }
        });

        // 滚动到指定区域再加载视频,video元素添加属性：data-lazyload
        const lazyVideos = document.querySelectorAll('video[data-lazyload]');
        lazyVideos.forEach(video => {
            const video_threshold = parseFloat(video.dataset.threshold) || 0.01
            const videoObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    // 元素完全进入视口
                    if (entry.isIntersecting) {
                        const video = entry.target;
                        const source = video.querySelector('source')
                        // 加载视频资源
                        if (source.dataset.src) {
                            source.src = source.dataset.src;
                            video.load()
                            source.removeAttribute('data-src');
                        }

                        // 加载封面图（可选）
                        if (video.dataset.poster) {
                            video.poster = video.dataset.poster;
                            video.removeAttribute('data-poster');
                        }

                        // 视频加载完成后，停止监听该元素
                        video.onloadeddata = () => {
                            observer.unobserve(video);
                        };
                    }
                });
            }, {
                root: null, // 根元素为视口
                rootMargin: '0px', // 视口边缘无扩展
                threshold: video_threshold // 元素100%可见时触发（完全进入视口）
            });
            videoObserver.observe(video);
        });

        $('video.video-lazyloadsec').each(function () {
            let video = $(this);
            if (video.parents(".section_video_list").offset().top < $(window).scrollTop() + $(window).height() && !video.attr('loaded')) {
                video.find('source').attr('src', video.find('source').attr('data-src'));
                video[0].load();
                video.attr('poster', video.attr('data-poster'));
                video.attr('loaded', true);
            }
        });

        $('video.lazyload-poster').each(function () {
            var video = $(this);
            if (video.offset().top < $(window).scrollTop() + $(window).height()) {
                video.attr('poster', video.attr('data-poster'));
                video.attr('loaded', true);
            }
        });



        // 模块缓入
        $('.scroll-animation').each(function () {
            var this_move = $(this);
            if (this_move.offset().top < $(window).scrollTop() + $(window).height() * 4 / 5 && !this_move.hasClass('active')) {
                this_move.addClass("active");
            }
        });
        $('.scroll-animation-05').each(function () {
            var this_move = $(this);
            if (this_move.offset().top < $(window).scrollTop() + $(window).height() * 4 / 5 && !this_move.hasClass('active')) {
                this_move.addClass("active");
            }
        });
    }

    $(window).on('scroll', lazyLoadAndAnimate);
    lazyLoadAndAnimate();





    // 1. 选择所有需要懒加载的 picture 元素
    const lazyPictures = document.querySelectorAll('.lazy-picture');

    // 2. 检测元素是否进入视口（支持 IntersectionObserver，性能更好）
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // 当元素进入视口，且还没加载过原图时
            if (entry.isIntersecting && !entry.target.classList.contains('loaded')) {
                const picture = entry.target;
                const sources = picture.querySelectorAll('source');
                const img = picture.querySelector('img');

                // 3. 替换 <source> 的 srcset：用 data-srcset（原图）覆盖 srcset（缩略图）
                sources.forEach(source => {
                    if (source.dataset.srcset) {
                        source.srcset = source.dataset.srcset;
                        // 可选：替换后删除 data-srcset，避免重复处理
                        delete source.dataset.srcset;
                    }
                });

                // 4. 替换 <img> 的 src：用 data-src（原图）覆盖 src（缩略图）
                if (img.dataset.src) {
                    img.src = img.dataset.src;
                    delete img.dataset.src;
                }

                // 5. 标记为已加载，避免重复处理
                picture.classList.add('loaded');
                // 停止观察该元素（节省性能）
                observer.unobserve(picture);
            }
        });
    }, {
        // 可选配置：元素进入视口 10% 时就触发加载（提前加载，避免白屏）
        threshold: 0.1
    });

    // 6. 给所有懒加载 picture 启动观察
    lazyPictures.forEach(picture => {
        observer.observe(picture);
    });

    // 7. 初始化时检查：如果元素已经在视口（比如首屏），直接加载原图
    lazyPictures.forEach(picture => {
        const rect = picture.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
            observer.unobserve(picture); // 取消观察，手动触发加载
            const sources = picture.querySelectorAll('source');
            const img = picture.querySelector('img');

            sources.forEach(s => s.dataset.srcset && (s.srcset = s.dataset.srcset));
            img.dataset.src && (img.src = img.dataset.src);
            picture.classList.add('loaded');
        }
    });
})